import { api, unwrap, type APIResponse } from "./client";

export interface EnqueueResult {
  accepted: number;
  skipped_invalid: number;
  already_registered: number;
  already_queued: number;
  outstanding: number;
}

export interface FcrStatus {
  running: boolean;
  pid: number | null;
  outstanding: number;
  queued: number;
  done: number;
  log_tail: string[];
}

export interface TriggerResult {
  started: boolean;
  pid: number | null;
  message: string;
}

export interface StopResult {
  stopped: boolean;
  pid: number | null;
  message: string;
}

export interface ClearResult {
  cleared: number;
  message: string;
}

export async function fcrEnqueue(
  numbers: string[],
  force = false,
): Promise<EnqueueResult> {
  const resp = await api.post<APIResponse<EnqueueResult>>("/fcr/enqueue", {
    numbers,
    force,
  });
  return unwrap(resp.data);
}

export async function fcrStatus(): Promise<FcrStatus> {
  const resp = await api.get<APIResponse<FcrStatus>>("/fcr/status");
  return unwrap(resp.data);
}

export async function fcrTrigger(): Promise<TriggerResult> {
  const resp = await api.post<APIResponse<TriggerResult>>("/fcr/trigger");
  return unwrap(resp.data);
}

export async function fcrStop(): Promise<StopResult> {
  const resp = await api.post<APIResponse<StopResult>>("/fcr/stop");
  return unwrap(resp.data);
}

export async function fcrClearQueue(): Promise<ClearResult> {
  const resp = await api.delete<APIResponse<ClearResult>>("/fcr/queue");
  return unwrap(resp.data);
}

export interface ProxyConfig {
  source: "custom" | "script-default";
  enabled: boolean;
  host: string;
  port: number;
  username: string;
  password_masked: string;
  raw_masked: string;
}

export interface ProxyIn {
  enabled: boolean;
  host: string;
  port: number;
  username: string;
  password: string;
}

export async function fcrGetProxy(): Promise<ProxyConfig> {
  const resp = await api.get<APIResponse<ProxyConfig>>("/fcr/proxy");
  return unwrap(resp.data);
}

export async function fcrSetProxy(body: ProxyIn): Promise<ProxyConfig> {
  const resp = await api.put<APIResponse<ProxyConfig>>("/fcr/proxy", body);
  return unwrap(resp.data);
}

export async function fcrResetProxy(): Promise<ProxyConfig> {
  const resp = await api.delete<APIResponse<ProxyConfig>>("/fcr/proxy");
  return unwrap(resp.data);
}
